module.exports = __webpack_public_path__ + "img/side-car.d562f5b5.png";